import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'
import { muteall } from '../action_x.js'
import { meetBlock } from '../ui.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    button.classList.add(utilities.modifiers.display.none)
    muteall()
  }
})

export default button => {
  const block = meetBlock()

  if (block.classList.contains(elements.meet_organizer_enabled)) {
    button.classList.add(elements.meet_organizer_enabled)
  } else {
    button.classList.remove(elements.meet_organizer_enabled)
  }

  onClick.listen(button)
}